import Service from "./Service";
import {
  SigninModel,
  ProfileInfo,
  SignupModel,
  PageList,
  RoleInfo,
  RoleInfoEntity,
  ContactInfoEntity,
  FlowInfoEntity,
  UserAccountEntity,
  UserAccountModel,
  InvoiceInfoEntity,
  BindModel,
  UserModel,
  ConfigInfo,
  ConferModel,
  ConferInfoEntity,
  ReferInfo,
} from "@/model/system";
// import * from '@/models.ts'

class UserService extends Service {
  signIn(signinModel: SigninModel) {
    return this.post<ProfileInfo>("/Security/Login", signinModel);
  }

  signUp(signupModel: SignupModel) {
    return this.post<ProfileInfo>("/Security/Register", signupModel);
  }
  signOut() {
    return this.post("/Security/Logout", "");
  }

  exists(loginName: string) {
    return this.get(`/home/exists?loginName=${loginName}`);
  }

  getProfileInfo() {
    return this.get<ProfileInfo>("/home/profile");
  }

  // /**
  //  * 获取成员信息
  //  * @param unionModel 授权模型
  //  * @param pageNo 分页页码
  //  * @param pageSize 分页大小
  //  */
  // getMemberList(unionModel?: UnionModel, pageNo = 1, pageSize = 15) {
  //     return this.post<PageList<RoleInfo>>(`/role/members?pageNo=${pageNo}&pageSize=${pageSize}`, unionModel);
  // }

  // getBasicList(roleIds: string[]) {
  //     return this.post<PageList<RoleInfo>>(`/user/basics`, roleIds);
  // }
  // associate(roleId: string) {
  //     return this.get<RoleInfo>(`/user/associate?roleId=${roleId}`);
  // }

  getConsumers() {
    return this.post<RoleInfoEntity[]>("/RoleInfo/getConsumers", {});
  }
  getSiteInfo() {
    return this.get(`/Security/GetSiteInfo`);
  }
  getRoleInfo(data: RoleInfoEntity) {
    return this.post<RoleInfoEntity>("/RoleInfo/Details", data);
  }
  getRoleInfoDetails(data: any) {
    return this.post("/RoleInfo/Details", data);
  }
  getNameList(data: String[]) {
    return this.post<RoleInfoEntity[]>("/RoleInfo/NameList", data);
  }
  getRoleList(data: RoleInfoEntity) {
    return this.post<PageList<RoleInfoEntity>>("/RoleInfo/List", data);
  }
  saveRoleInfo(data: RoleInfoEntity) {
    return this.post<string>("/RoleInfo/Update", data);
  }
  getTicketInfo(options: any) {
    return this.post("/Security/GetTicketInfo", "", options);
  }
  getContactList(data: ContactInfoEntity) {
    return this.post<PageList<ContactInfoEntity>>(`/ContactInfo/List`, data);
  }
  sendCode(model: UserAccountModel) {
    return this.post(`/Security/SendCode`, model);
  }
  sendValidCode(data: any) {
    return this.post(`/Security/SendValidCode`, data);
  }
  getFlowInfo(FlowID: string) {
    return this.get<FlowInfoEntity>(`/FlowInfo/Details/${FlowID}`);
  }
  getContactInfo(ContactID: string) {
    return this.get<ContactInfoEntity>(`/ContactInfo/Details/${ContactID}`);
  }
  saveContactInfo(data: ContactInfoEntity) {
    return this.post<number>(`/ContactInfo/Update`, data);
  }
  deleteContactInfo(ContactID: string) {
    return this.get<number>(`/ContactInfo/Delete/${ContactID}`);
  }
  deleteRoleInfo(id: string, spaceId: string, ownerType: number) {
    return this.get<number>(`/RoleInfo/Delete/${id}?spaceId=${spaceId}&ownerType=${ownerType}`);
  }
  checkAccount(data: UserAccountModel) {
    return this.post<PageList<string>>(`/Security/CheckAccount`, data);
  }
  checkCode(data: UserAccountModel) {
    return this.post(`/Security/checkCode`, data);
  }

  resetPwd(data: UserAccountModel) {
    return this.post("/Security/ResetPwd", data);
  }
  getInvoiceList(data: InvoiceInfoEntity) {
    return this.post<PageList<InvoiceInfoEntity>>(`/InvoiceInfo/List`, data);
  }
  saveInvoiceInfo(data: InvoiceInfoEntity) {
    return this.post<number>(`/InvoiceInfo/Update`, data);
  }
  deleteInvoiceInfo(InvoiceID: string) {
    return this.get<number>(`/InvoiceInfo/Delete/${InvoiceID}`);
  }
  getAccountList(data: UserAccountEntity) {
    return this.post("/UserAccount/List", data);
  }
  initializePassword(data: UserAccountModel) {
    return this.post<number>("/UserAccount/InitializePassword", data);
  }
  deleteAccountInfo(UserAct: string) {
    return this.get<number>(`/UserAccount/Delete?UserAct=${UserAct}`);
  }

  authSendCode(data: BindModel) {
    return this.post<string>(`/auth/SendCode`, data);
  }
  authBind(data: BindModel) {
    return this.post(`/auth/Bind`, data);
  }
  getOwners(data: RoleInfoEntity) {
    return this.post<PageList<UserModel>>("/RoleInfo/Owners", data);
  }
  getConferList(data: ConferInfoEntity) {
    return this.post<PageList<ConferInfoEntity>>(`/ConferInfo/List`, data);
  }
  getConferInfo(data: ConferInfoEntity) {
    return this.post<ConferInfoEntity>(`/ConferInfo/Details`, data);
  }
  saveConferInfo(data: ConferInfoEntity) {
    /**
     * @method 保存授权信息
     */
    // data = {
    //     OwnerID: 'S000000000',//获得权限的人
    //     ConferDate: '2018-12-04 09:00:00',//授予日期
    //     ExpiryDate: '2018-12-04 09:00:00',//过期日期
    // }
    return this.post<number>(`/ConferInfo/Save`, data);
  }
  deleteConferInfo(data: ConferInfoEntity) {
    return this.post<ConferInfoEntity>(`/ConferInfo/Delete`, data);
  }

  getServiceList() {
    return this.get<any>(`/ConferInfo/GetServiceList`);
  }

  getConfigList(data: ConfigInfo) {
    return this.post<PageList<ConfigInfo>>(`configinfo/ConfigInfoList`, data);
  }
  getCompanyConfigs() {
    return this.post<ConfigInfo[]>(`configinfo/CompanyConfigs`, {});
  }
  saveConfigInfo(data: ConfigInfo) {
    return this.post<number>(`configinfo/ConfigInfoSave`, data);
  }

  AccountExists(data: UserAccountModel) {
    return this.post<boolean>(`/Security/AccountExists`, data);
  }
  getReferInfo(id: string) {
    return this.get<ReferInfo>(`/auth/getReferInfo?ReferID=${id}`);
  }
  getCompanyExtra(data: {ExtraCode: string, MasterID: string}) {
    return this.post<{ExtraCode: string, MasterID: string,ExtraData: string}>(`/extrainfo/SearchExtraInfo`, data);
  }
}
export default new UserService("system");
